import React, { Component } from "react";

import { ChromePicker } from "react-color";
import { Button } from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { withStyles } from "@material-ui/styles";

const style = {
  picker: {
    width: "100% !important",
    marginTop: "2rem",
  },
  addColor: {
    width: "100%",
    padding: "1rem",
    marginTop: "1rem",
    fontSize: "1rem",
  },
  ColorNameInput: {
    width: "100%",
    height: "70px",
  },
};
class ColorPickerForm extends Component {
  render() {
    const {
      handleChangeComplete,
      newName,
      handleChange,
      background,
      colors,
      addNewColor,
      classes,
    } = this.props;
    return (
      <div>
        <ChromePicker
          className={classes.picker}
          color={background}
          onChangeComplete={(newColor) => handleChangeComplete(newColor)}
        />
        <ValidatorForm onSubmit={addNewColor}>
          <TextValidator
            className={classes.ColorNameInput}
            margin="normal"
            variant="filled"
            value={newName}
            onChange={handleChange}
            validators={["required"]}
            errorMessages={["this field is required"]}
          />
          <Button
            className={classes.addColor}
            type="submit"
            variant="contained"
            color="primary"
            style={{ background: background }}
            disabled={colors.length >= 20}
          >
            ADD COLOR
          </Button>
        </ValidatorForm>
      </div>
    );
  }
}
export default withStyles(style)(ColorPickerForm);
